import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-0 flex-col bg-black bg-opacity-60 flex inset-0 items-center justify-center w-screen h-screen",
  style: {"z-index":"10000"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-12 w-12 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-white" }, "Carregando...", -1)
const _hoisted_4 = {
  key: 0,
  class: "my-8 bg-gray-700 rounded p-3 px-5 text-gray-50"
}

import { ref, watch } from "vue";
import axios from "@/axios";
import { AxiosError } from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  setup(__props) {

const activeRequests = ref(0);
const tooLong = ref(false);
let timeout = 0;

watch(activeRequests, (val) => {
  if (val > 0) {
    document.body.style.overflow = "hidden";
    clearTimeout(timeout);
    timeout = setTimeout(takingTooLong, 20000);
    return;
  }

  clearTimeout(timeout);
  tooLong.value = false;
  document.body.style.overflow = "";
});

const takingTooLong = () => {
  tooLong.value = true;
};

axios.interceptors.request.use(function (config: any) {
  if (!config?.customLoader) {
    activeRequests.value += 1;
  }
  return config;
});

axios.interceptors.response.use(
  (response: any) => {
    if (!response?.config?.customLoader && activeRequests.value > 0) {
      activeRequests.value -= 1;
    }
    return response;
  },
  (error: any) => {
    if (!error?.config?.customLoader && activeRequests.value > 0) {
      activeRequests.value -= 1;
    }
    const axiosError = error as AxiosError;
    return Promise.reject(axiosError);
  }
);

const reload = () => {
  document.location.reload();
};

return (_ctx: any,_cache: any) => {
  return (activeRequests.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (tooLong.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createTextVNode(" Demorando muito? Tente "),
              _createElementVNode("a", {
                onClick: reload,
                class: "cursor-pointer underline"
              }, " recarregar a página")
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})